import React from "react";
import { H2, H5, Callout, Spinner, Button, Dialog, Classes, InputGroup, FormGroup, Switch, Alert, Icon } from "@blueprintjs/core";
import { withTranslation, Trans } from "react-i18next";
import i18next from "i18next";
import InfiniteScroll from 'react-infinite-scroller';
import { w3cwebsocket as W3CWebSocket } from "websocket";

import { getLoggedUser, getLoggedUserLevel } from "../auth/Signin";

import { authenticatedGetFetch, authenticatedPutFetch, authenticatedPostFetch, getBackendRoute } from "../../utils/AuthenticatedFetch";
import i18n from '../../i18n';

function solveNotification(id, message) {
  authenticatedPutFetch('/notification', { id: id, message: message }, (response) => { });
}

class Notification extends React.Component {
  constructor() {
    super();
    this.state = {
      solving: false,
      message: ""
    }
  }
  render() {
    const closingMessage = (this.props.notif.closingMessage !== undefined && this.props.notif.closingMessage !== null && this.props.notif.closingMessage.length > 0) ?
      <div>
        <Trans>with information:</Trans><i>{this.props.notif.closingMessage}</i>
      </div> : null;
    const closingInfo = (this.props.notif.closingDate !== undefined && this.props.notif.closingDate !== null) ?
      <div>
        {(this.props.notif.closedBy === null || this.props.notif.closedBy === undefined) ?
          <span><Trans>detected as solved</Trans> </span>
          :
          <span><Trans>solved by</Trans><b><i>{this.props.notif.closedBy.login}</i></b> </span>
        }
        <Trans>on</Trans> {new Date(this.props.notif.closingDate).toLocaleString(i18next.language)}
      </div>
      : null;
    return (
      <div style={{ marginTop: "10px" }}>
        <Callout intent={this.props.notif.alert.intent}>
          <div className="flexbox-center-large">
            <div>
              <H5>{this.props.notif.alert.lbl}</H5>
              <div><Trans>park</Trans> n°{this.props.notif.park} <Trans>equipment</Trans> n°{this.props.notif.equipment}</div>
              <div>{new Date(this.props.notif.date).toLocaleString(i18next.language)}</div>
              <div><b><Trans>{"event" + this.props.notif.event}</Trans></b></div>
            </div>
            <div>
              {(this.props.notif.closingDate !== null && this.props.notif.closingDate !== undefined) ?
                <Callout intent="success">
                  {closingInfo}
                  {closingMessage}
                </Callout>
                :
                <Button
                  onClick={() => { this.setState({ solving: !this.state.solving }); }}
                  icon="cross"
                >
                  <Trans>solve</Trans>
                </Button>
              }
            </div>
          </div>
        </Callout>
        <Dialog
          hasBackdrop={false}
          style={{ transition: 'none' }}
          isOpen={this.state.solving}
          canEscapeKeyClose={true}
          canOutsideClickClose={true}
          autoFocus={true}
          className={Classes.OVERLAY_SCROLL_CONTAINER}
          onClose={() => { this.setState({ solving: !this.state.solving }); }}
        >
          <div className={Classes.DIALOG_BODY}>
            <Callout intent="primary"><Trans>this notification will be displayed as solved for all other users</Trans></Callout>
            <FormGroup
              label={<Trans>solving message</Trans>}
              labelFor="message"
            >
              <InputGroup
                type="text"
                id="message"
                value={this.state.message}
                onChange={(ti) => { this.setState({ message: ti.target.value }); }}
              />
            </FormGroup>
          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <Button
              icon='undo'
              intent="danger"
              onClick={() => { this.setState({ solving: false }) }}
            >
              <Trans>cancel</Trans>
            </Button>
            <Button
              icon='tick'
              onClick={() => { solveNotification(this.props.notif.id, this.state.message); this.setState({ solving: false }) }}
            >
              <Trans>solve</Trans>
            </Button>
          </div>
        </Dialog>
      </div>
    );
  }
}

class NotificationsPage extends React.Component {
  constructor() {
    super();
    this.state = {
      notifications: {},
      hasMore: true,
      pointer: 0,
      loading: true,
      hideSolved: false,
      solveAllOpen: false
    }
  }

  componentDidMount() {
    this.setState({ permChanged: new Date(), user: getLoggedUser() })
    if (getLoggedUserLevel() > 0) {
      authenticatedGetFetch('/notifications?limit=5',
        (response) => {
          this.setState({
            loading: false,
            notifications: Object.fromEntries(Object.entries(response).map(([key, val]) => [val["id"], val])),
            pointer: response.length
          });
          this.client = new W3CWebSocket(getBackendRoute("WS") + "/notifications/flow", ["Bearer", localStorage.getItem('token')]);
          this.client.onmessage = (message) => {
            const tmp = this.state.notifications;
            try {
              const data = JSON.parse(message.data);
              tmp[data.id] = data;
              this.setState({ notifications: tmp, pointer: this.state.pointer + 1 });
            } catch (e) {
              console.error("Error while parsing " + JSON.stringify(message));
            }
          };
        });
    }
  }

  componentWillUnmount() {
    if (this.client !== undefined)
      this.client.close();
  }

  render() {
    const ret = [];
    for (const id of Object.keys(this.state.notifications).sort().reverse())
      ret.push(<Notification key={id} notif={this.state.notifications[id]} />);

    return (
      <div>
        <div className="component-body" id="page">
          <H2><Icon icon="notifications" size="25" /><Trans>your notifications</Trans></H2>
          <div className="flexbox-center-large">
            <Switch
              checked={this.state.hideSolved}
              label={i18n.t("hide solved alerts")}
              onChange={(cb) => {
                this.setState({ hideSolved: cb.target.checked, notifications: {} }, () => {
                  authenticatedGetFetch('/notifications?limit=' + this.state.pointer + "&hidesolved=" + this.state.hideSolved,
                    (response) => {
                      this.setState({
                        loading: false,
                        notifications: Object.fromEntries(Object.entries(response).map(([key, val]) => [val["id"], val]))
                      });
                    });
                });
              }}
            />
            <Alert
              confirmButtonText={<Trans>solve all active alerts</Trans>}
              cancelButtonText={i18n.t("cancel")}
              isOpen={this.state.solveAllOpen}
              onClose={() => this.setState({ solveAllOpen: false })}
              onCancel={() => this.setState({ solveAllOpen: false })}
              onConfirm={() => authenticatedPostFetch('/notifications/solveAll', {})}
              canEscapeKeyCancel={true}
              canOutsideClickCancel={true}
              intent="warning"
              icon="high-priority"
            >
              <p><Trans>this action will set all the notifications as solved for all the users attached to the concerned alerts</Trans></p>
            </Alert>
            <Button onClick={() => { this.setState({ solveAllOpen: true }) }}><Trans>solve all active alerts</Trans></Button>
          </div>
          <InfiniteScroll
            pageStart={0}
            loadMore={(page) => {
              authenticatedGetFetch("/notifications?limit=5&offset=" + (page * 5) + "&hidesolved=" + this.state.hideSolved,
                (response) => {
                  this.setState({
                    notifications: { ...Object.fromEntries(Object.entries(response).map(([key, val]) => [val["id"], val])), ...this.state.notifications },
                    loading: false,
                    hasMore: (response.length === 5),
                    pointer: this.state.pointer + response.length
                  });
                });
            }}
            hasMore={this.state.hasMore}
            loader={<Spinner />}
            useWindow={true}
          >
            {ret}
          </InfiniteScroll>
        </div>
      </div>
    )
  }
}

export default withTranslation()(NotificationsPage)
